import { render, staticRenderFns } from "./CitasSimple.vue?vue&type=template&id=2f347799&scoped=true"
import script from "./CitasSimple.vue?vue&type=script&lang=js"
export * from "./CitasSimple.vue?vue&type=script&lang=js"
import style0 from "./CitasSimple.vue?vue&type=style&index=0&id=2f347799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f347799",
  null
  
)

export default component.exports